// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2z0Du","alertIcon":"ConfirmModal_alertIcon__2R03T"};